import {
    cleanCommonParams,
    mapAttachmentParams,
} from './common';

const mapPremierAccessGroupsImportsParams = (
    isCreate,
    {
        attachment,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            premier_access_groups_import: {
                ...cleanCommonParams(params),
                ...mapAttachmentParams(isCreate, attachment),
            },
        });
    });
};

export { mapPremierAccessGroupsImportsParams };
